import {
  ChangeDetectionStrategy,
  Component,
  computed,
  CUSTOM_ELEMENTS_SCHEMA,
  type ElementRef,
  inject,
  input,
  type OnInit,
  viewChild,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ControlsVisibility } from '../../../../services/controls-visibility/controls-visibility';

@Component({
  selector: 'nr-navigation-button',
  imports: [TranslatePipe],
  templateUrl: './navigation-button.html',
  styleUrl: './navigation-button.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class NavigationButtonComponent implements OnInit {
  private readonly controlsVisibility = inject(ControlsVisibility);

  private readonly buttonElement = viewChild.required<ElementRef<HTMLElement>>('button');

  readonly direction = input.required<'prev' | 'next'>();

  readonly isVisible = this.controlsVisibility.isNavigationButtonsVisible;
  readonly description = computed(
    () => `READER.NAVIGATION_BUTTON.${this.direction().toUpperCase()}`,
  );
  readonly icon = computed(() => (this.direction() === 'prev' ? 'navigate_back' : 'navigate_next'));

  ngOnInit(): void {
    this.controlsVisibility.addElementsToGroup('navigation-buttons', [
      this.buttonElement().nativeElement,
    ]);
  }
}
